/* ===== Price rounding ONLY (safe: won’t touch reviews) ===== */
(() => {
  const MODE = "99"; // "99" => x.99, "00" => x.00

  // Only these areas will be modified
  const PRICE_ZONES = [
    ".product", ".product__info", ".product__price", ".price", ".money",
    ".bundle", ".quantity-break", ".quantity_break",
    ".cart-drawer", ".drawer", ".mini-cart", ".cart",
    ".sticky-atc"
  ].join(",");

  // Never touch these areas (reviews/ratings)
  const EXCLUDE = [
    ".areviews", "#areviews", "[data-areviews]",
    ".jdgm", "#judgeme_product_reviews", "[data-judgeme]",
    ".loox", "[data-loox]",
    ".stamped", "[data-stamped]",
    ".spr", "#shopify-product-reviews",
    "[data-rating]",
    "[class*='review']", "[id*='review']",
    "[class*='rating']", "[id*='rating']",
    "[aria-label*='star']"
  ].join(",");

  const hasCurrencyNearby = (el) => {
    if (!el) return false;
    const t = (el.textContent || "");
    if (/[$£€]/.test(t)) return true;
    const p = el.parentElement;
    if (p && /[$£€]/.test(p.textContent || "")) return true;
    return false;
  };

  const parseNum = (text) => {
    const m = text.match(/(\d[\d\s.,]*)/);
    if (!m) return null;

    let num = m[1].replace(/\s/g, "");
    const lastDot = num.lastIndexOf(".");
    const lastComma = num.lastIndexOf(",");
    const decSep = lastComma > lastDot ? "," : ".";

    if (decSep === ",") {
      num = num.replace(/\./g, "");
      num = num.replace(/,/g, ".");
    } else {
      num = num.replace(/,/g, "");
    }

    const v = parseFloat(num);
    return Number.isFinite(v) ? v : null;
  };

  const roundVal = (v) => {
    if (!Number.isFinite(v)) return v;
    if (MODE === "00") return Math.round(v);
    return Math.floor(v) + 0.99;
  };

  const replaceNumber = (oldText, newVal) => {
    const fixed = newVal.toFixed(2);
    const usesCommaDecimal = /,\d{2}\b/.test(oldText) && !/\.\d{2}\b/.test(oldText);
    const out = usesCommaDecimal ? fixed.replace(".", ",") : fixed;
    return oldText.replace(/(\d[\d\s.,]*)/, out);
  };

  const processLeaf = (el) => {
    if (!el || el.nodeType !== 1) return;
    if (el.closest(EXCLUDE)) return;
    if (!el.closest(PRICE_ZONES)) return;
    if (el.children.length) return;

    const text = (el.textContent || "").trim();
    if (!text || text.length > 32) return;

    // Key: must have currency symbol nearby
    if (!hasCurrencyNearby(el)) return;

    const v = parseNum(text);
    if (v === null) return;

    const r = roundVal(v);
    if (Math.abs(r - v) < 0.0001) return;

    el.textContent = replaceNumber(text, r);
  };

  const run = (root = document) => {
    const scope = root.nodeType === 1 ? root : document;

    scope.querySelectorAll(PRICE_ZONES).forEach(zone => {
      if (zone.closest(EXCLUDE)) return;
      zone.querySelectorAll("*").forEach(processLeaf);
    });
  };

  // Initial + dynamic updates (bundle widgets update DOM)
  const init = () => {
    run(document);

    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        m.addedNodes && m.addedNodes.forEach(n => {
          if (n.nodeType === 1) run(n);
  });
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  };

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
